import React from "react";
import { toast, ToastContainer } from "react-toastify";

// One reusable, customizable message toast (single container div, single message div),
// built on top of the react-toastify already used elsewhere in this app (HomePage.js,
// LoginPage.js, OffersNdBenefits.js) so styling/behaviour stays consistent.
//
// Mount <Toast /> once per page/route that needs it, then trigger it from anywhere with:
//   showToast(translation?.someMessage);
//   showToast(translation?.someMessage, { position: "bottom-center", duration: 4000 });
export const showToast = (
  message,
  {
    position = "bottom-center",
    duration = 3000,
    className = "",
    closeButton = true,
    hideProgressBar = true,
    closeOnClick = false,
  } = {}
) => {
  if (!message) return;
  toast(<div className="app-toast-message">{message}</div>, {
    position,
    autoClose: duration,
    closeButton,
    hideProgressBar,
    closeOnClick,
    pauseOnHover: true,
    draggable: true,
    icon: false,
    className: `app-toast-container ${className}`.trim(),
    bodyClassName: "app-toast-body",
  });
};

const Toast = () => <ToastContainer className="app-toast-wrapper" />;

export default Toast;
